import React, { useEffect, useState } from "react";
import { Modal, Form, Input, Col, Row, message, Upload, Image } from "antd";
import { API_METHODS } from "../../constants";
import useApi from "../../hooks/useApi";
import { InboxOutlined } from "@ant-design/icons";

function AddNotice(props) {
  const [form] = Form.useForm();
  const { visible, close, selectedRecord } = props;
  const [response, request] = useApi(
    "/admin/notice",
    null,
    API_METHODS.POST,
    true // for multipart data
  );
  const [editResponse, editRequest] = useApi(
    `/admin/notice/${selectedRecord && selectedRecord.id}`,
    null,
    API_METHODS.PUT,
    true
  );
  const [disableForm, setDisableForm] = useState(false);
  const [messageApi, contextHolder] = message.useMessage();

  useEffect(() => {
    if (response.data) {
      setDisableForm(false);
      close(true);
      messageApi.open({
        type: "success",
        content: "Notice added successfully",
      });
    } else if (response.error) {
      close(true);
    }
  }, [response]);

  useEffect(() => {
    if (editResponse.data) {
      setDisableForm(false);
      close(true);
      messageApi.open({
        type: "success",
        content: "Notice updated successfully",
      });
    } else if (editResponse.error) {
      close(true);
    }
  }, [editResponse]);

  useEffect(() => {
    if (selectedRecord) {
      form.setFieldsValue({
        heading: selectedRecord.heading,
        notice: selectedRecord.notice,
      });
    }
  }, [selectedRecord]);

  const handleOk = () => {
    form
      .validateFields()
      .then((values) => {
        setDisableForm(true);
        const formData = new FormData();
        for (const name in values) {
          if (name === "image") {
            if (values["image"] !== undefined) {
              formData.append(
                "image",
                values["image"].file.originFileObj,
                values["image"].file.name
              );
            }
          } else {
            formData.append(name, values[name]);
          }
        }
        if (selectedRecord) {
          editRequest(formData);
        } else {
          request(formData, API_METHODS.POST);
        }
      })
      .catch((e) => {});
  };

  const handleCancel = () => {
    close();
  };

  const uploadProps = {
    beforeUpload: (file) => {
      const isImage = file.type === "image/png" || file.type === "image/jpeg";
      if (!isImage) {
        messageApi.open({
          type: "error",
          content: `${file.name} error. Only PNG and JPEG files supported`,
        });
        return Upload.LIST_IGNORE;
      }
      return isImage;
    },
  };

  const dummyRequest = ({ file, onSuccess }) => {
    setTimeout(() => {
      onSuccess("ok");
    }, 0);
  };

  return (
    <Modal
      title={selectedRecord ? "Update Notice" : "Add Notice"}
      open={visible}
      onOk={handleOk}
      onCancel={handleCancel}
      width={1000}
      okText="Save"
    >
      {contextHolder}
      <Form layout="vertical" form={form} disabled={disableForm}>
        <Row gutter={16}>
          <Col span={8}>
            <Form.Item
              name="heading"
              label="Heading"
              rules={[
                { required: true, message: "Heading is required." },
                {
                  max: 50,
                  message: "Heading should be maximum of 50 characters.",
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="notice"
              label="Notice"
              rules={[
                { required: true, message: "Notice is required." },
                {
                  max: 500,
                  message: "Notice should be maximum of 500 characters.",
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={24}>
            <Form.Item
              name="image"
              rules={[{ required: true, message: "Image is required." }]}
            >
              <Upload.Dragger
                customRequest={dummyRequest}
                {...uploadProps}
                maxCount={1}
              >
                <p className="ant-upload-drag-icon">
                  <InboxOutlined />
                </p>
                <p className="ant-upload-text">
                  Click or drag file to this area to upload
                </p>
              </Upload.Dragger>
            </Form.Item>
          </Col>
        </Row>
        <Row>
          {selectedRecord && <Image src={selectedRecord.image} width={100} />}
        </Row>
      </Form>
    </Modal>
  );
}

export default AddNotice;
